var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isUser && _vm.format.showOwners && _vm.statuses === 1)?_c('div',{staticClass:"owners"},[_c('app-game-item-field-name-owners',{attrs:{"format":_vm.format,"item":_vm.item}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }